module.exports = __webpack_public_path__ + "media/categories/1103-bb5d769f.svg";